<template>
    <div class="tab-menu-wrap" v-if="$store.getters.getHost != 'H0009'">
        <ul class="tab-menu">
            <li class="tab-menu__item active"><router-link :to="`/${$store.getters.getLang}/centerList`"> Center Introduction </router-link></li>
            <li class="tab-menu__item"><router-link :to="`/${$store.getters.getLang}/doctorList`"> Medical Staff Search </router-link></li>
        </ul>
    </div>
    <div class="list-form lang">
        <ul class="list-form__list">
            <li class="list-form__item" v-for="center in centerList">
                <router-link :to="`/${$store.getters.getLang}/center?deptCd=${center.deptCd}`">
                    <span class="icon"><img :src="`/displayFile.do?name=${center.thumbAttach.savedName}`" alt="" v-if="center.thumbAttach && center.thumbAttach.savedName"></span>
                    <span>{{center.deptNmGlb}}</span>
                </router-link>
            </li>
        </ul>
    </div>

</template>

<script>
export default {
    data() {
        return {
            centerList: []
        }
    },
    mounted() {
        this.axios.get(this.api.department.list, {
            params: {
                hospId: this.$store.getters.getHost,
                deptType: 1,
                startIndex: 1,
                langCd: this.$store.getters.getLang,
                orderType: 'sortOrd'
            }
        }).then(res => {
            this.centerList = res.data
        })
    },
}
</script>